import { useState } from "react";
import { Lock } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { useSite } from "@/lib/site";

export default function ReserveDialog({ open, onOpenChange }) {
  const L = useSite();
  const [f, setF] = useState({ name: "", club: "", email: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/payments/checkout", { ...f, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (err) {
      setError(apiError(err));
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[460px] rounded-[14px]" data-testid="reserve-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Réserver ma place fondateur</DialogTitle>
          <DialogDescription>{L.founderPrice} la première année. Vous serez redirigé vers le paiement sécurisé Stripe.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <label className="block"><span className="field-label">Votre nom</span><input className="field" required minLength={2} autoComplete="name" value={f.name} onChange={set("name")} data-testid="reserve-name-input" /></label>
          <label className="block"><span className="field-label">Nom du club</span><input className="field" required minLength={2} value={f.club} onChange={set("club")} data-testid="reserve-club-input" /></label>
          <label className="block"><span className="field-label">Email</span><input className="field" type="email" required autoComplete="email" value={f.email} onChange={set("email")} data-testid="reserve-email-input" /></label>
          {error && <p className="text-sm text-[#8A4B00] bg-[#FDEBD3] rounded-lg px-3 py-2" data-testid="reserve-error">{error}</p>}
          <button type="submit" className="btn-primary w-full h-12" disabled={busy} data-testid="reserve-submit-button"><Lock size={15} /> {busy ? "Redirection vers Stripe…" : `Payer ${L.founderPrice}`}</button>
          <p className="text-xs text-[#5B665F] text-center">Remboursé si l'outil n'est pas livré le {L.deliveryDate} ou si vous n'êtes pas satisfait après 30 jours.</p>
        </form>
      </DialogContent>
    </Dialog>
  );
}
